import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { ExperienceQuestions } from 'features/profile';
import { setPastInfo } from 'features/profile/helpers';
import { DisplayInfo } from 'shared/components';

class PastExperience extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: props.user,
      info: setPastInfo(props.user, props.t),
    };

    this.getInfoEditable = this.getInfoEditable.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user !== this.props.user) {
      this.setState({
        user: this.props.user,
        info: this.props.user ? setPastInfo(this.props.user, this.props.t) : [],
      });
    }
  }

  onChange(key, value) {
    this.setState((prevState) => ({
      ...prevState,
      user: {
        ...prevState.user,
        [key]: value,
      },
    }));
  }

  getInfoEditable() {
    const { user } = this.state;

    return (
      <div className="profile-content">
        <h4>{this.props.t('profile.pastExperience.title')}</h4>
        <ExperienceQuestions user={this.state.user} onChange={this.onChange} />
        <div className="buttons-container">
          <button type="button" onClick={() => this.props.cancel(2)} className="btn w-50">
            {this.props.t('common.labels.back')}
          </button>
          <button
            type="button"
            onClick={() => this.props.onSave(user, 2)}
            className="btn btn-primary w-50 ">
            {this.props.t('common.labels.continue')}
          </button>
        </div>
      </div>
    );
  }

  render() {
    const { editInfo } = this.props;

    return editInfo ? (
      this.getInfoEditable()
    ) : (
      <DisplayInfo
        info={this.state.info}
        onEdit={() => this.props.onEdit('experience')}
        buttonLabel="common.labels.updateInfo"
      />
    );
  }
}

PastExperience.propTypes = {
  onEdit: PropTypes.func,
  editInfo: PropTypes.bool,
  cancel: PropTypes.func,
  onSave: PropTypes.func,
  user: PropTypes.shape({}).isRequired,
  t: PropTypes.func.isRequired,
};

PastExperience.defaultProps = {
  editInfo: false,
  onEdit: () => {},
  close: () => {},
  onSave: () => {},
};

export default withTranslation()(PastExperience);
